<template>
  <v-tabs centered color="#44517B" dark icons-and-text>
    <v-tabs-slider color="#27DABC"></v-tabs-slider>

    <v-tab href="#tab-1">
      Configurações gerais
      <v-icon>schedule</v-icon>
    </v-tab>

    <v-tab href="#tab-2">
      Taxas
      <v-icon>percent</v-icon>
    </v-tab>

    <v-tab-item :key="1" :value="'tab-1'">
      <v-card flat>
        <v-container>
          <h2>Configurações gerais</h2>
          <v-layout>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select xs3 :items="exchange_mode_values" v-model="partner_config.exchange_mode"
                label="Regra de acionamento de câmbio"></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select xs3 :items="automatic_exchange_values" v-model="partner_config.automatic_exchange"
                label="Fechamento do câmbio"></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select xs3 margin4 :items="allow_credit_card_values" v-model="partner_config.allow_credit_card"
                label="Transações Cartão"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select xs3 :items="boolean_values" v-model="partner_config.extra_cpf_check"
                label="Checagem de CPF (serpro)"></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select xs3 :items="boolean_values" v-model="partner_config.allow_automatic_pix"
                label="Envio de PIX automático"></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select
                :items="boolean_values"
                v-model="partner_config.allow_automatic_spei"
                label="Envio de SPEI automático"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select
                :items="boolean_values"
                v-model="partner_config.allow_automatic_cobre"
                label="Envio COBRE automático"
              ></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select :items="boolean_values" v-model="partner_config.store_bank_account"
                label="Cadastrar conta ao receber PIX de clientes"></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select :items="boolean_values" v-model="partner_config.verify_payer_document"
                label="Verificar documento do pagador"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select :items="boolean_values" v-model="partner_config.allow_to_create_many_internal_bank_accounts"
                label="Permitir criação de muitas contas bancárias internas"></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select :items="boolean_values" v-model="partner_config.disable_autoschedule_creation"
                label="Desabilitar criação de transações por autoschedule"></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select
                :items="boolean_values"
                v-model="partner_config.disable_rfc_pf_curp_validation"
                label="Desabilitar verificação de correspondência entre rfc_pf e curp"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select
                :items="boolean_values"
                v-model="partner_config.allow_to_create_transaction_without_subject"
                label="Permitir criar transações sem informar pagador"
              ></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select
                :items="boolean_values"
                v-model="partner_config.allow_dynamic_clabe"
                label="Habilitar criação de transações usando clabe dinâmca"
              ></v-select>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select
                :items="allow_checkout_page_values"
                v-model="partner_config.allow_checkout_page"
                label="Habilitar página de checkout"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select
                :items="boolean_values"
                v-model="partner_config.allow_financial_account_requests"
                label="Permitir criação de contas FacilitaBank"
              ></v-select>
            </v-flex>
            <v-flex v-if="!createNewPartner" xs4 style="padding: 0 4px 0 4px">
              <v-text-field
                v-model="partner_config.global_pix_bank_account_id"
                label="Global pix bank account id"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 style="padding: 0 4px 0 4px">
              <font color="#757575" style="font-size: 12px;">Desabilitar handle clearance por País</font>
              <v-layout class="col" style="overflow: auto !important;">
                <v-flex>
                  <v-checkbox
                    style="margin: 0 15px 0 0;"
                    v-model="partner_config.disable_handle_clearance_by_currency"
                    label="BRL"
                    value="BRL"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    style="margin: 0 15px 0 0;"
                    v-model="partner_config.disable_handle_clearance_by_currency"
                    label="MXN"
                    value="MXN"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    style="margin: 0 15px 0 0;"
                    v-model="partner_config.disable_handle_clearance_by_currency"
                    label="COP"
                    value="COP"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
           <v-flex xs4 style="padding: 0 4px 0 4px">
              <v-select :items="boolean_values" v-model="partner_config.legacy_webhooks"
                label="Webhook legado"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex v-if="!createNewPartner" class="d-flex">
              <v-btn dark :disabled="loading" color="#41DFC4" @click="updatePartnerConfig">
                Atualizar
              </v-btn>
            </v-flex>
          </v-layout>
          <v-snackbar v-model="display_feedback" :color="feedback_color" :timeout="3000" bottom>
            {{this.feedback_text}}
          </v-snackbar>
        </v-container>
      </v-card>
    </v-tab-item>

    <v-tab-item :key="2" :value="'tab-2'">
      <v-card flat>
        <v-container>
          <h2>Taxas fixas</h2>
          <h3>FX</h3>
          <v-layout wrap>
            <v-flex xs4 md2 pr-1 v-for="(item, index) in fx_rates_list" :key="index" style="display: flex;">
              <v-currency-field v-bind="currency_config" :label="item[0]" v-model="item[1]">
              </v-currency-field>
              <v-btn dark icon small color="primary" @click="removeRateFromFxList(index)">
                <v-icon dark>remove</v-icon>
              </v-btn>
            </v-flex>
            <v-text-field label="Incluir nova" hint="Exemplos: MXN_overnight, MXNUSD..." v-model="fx_rate_value">
            </v-text-field>
            <v-btn fab dark small color="primary" @click="addRateToFxList()">
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-layout>
          <h2>Taxas dinâmicas</h2>
          <v-layout row wrap v-if="this.record.company_taxes">
            <v-flex xs12 md9 px-1>
              <v-select box clearable return-object item-text="label" item-value="value" append-icon="local_atm"
                label="Selecione a taxa" :items="company_taxes_items" v-model="selected_company_tax"
                @click:clear="selected_company_tax = {}"></v-select>
            </v-flex>
            <v-flex xs12 md3 px-1>
              <v-btn color="#27DABC" @click="addTaxToList">Adicionar</v-btn>
            </v-flex>
            <v-flex xs12 py-0 v-for="(tax_item, index) in company_taxes_list" :key="tax_item.value">
              <div class="partner-taxes">
                <TaxItem :tax_name="tax_item.value" :tax_ruleset="tax_item.rules" @updateRules="updateRulesForTax" />
                <v-btn fab dark small color="primary" @click="removeTaxFromList(index)">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12 md3 px-1>
              <v-btn v-if="!createNewPartner" dark :disabled="loading" color="#41DFC4" @click="updateCompanyTaxes">
                Atualizar
                <v-progress-circular :indeterminate="loading" :value="0" size="22" class="ml-2"></v-progress-circular>
              </v-btn>
            </v-flex>
            <v-snackbar v-model="display_feedback" :color="feedback_color" :timeout="3000" bottom>
              {{this.feedback_text}}
            </v-snackbar>
          </v-layout>
        </v-container>
      </v-card>
      <error-dialog
        :show_error_dialog="show_error_dialog"
        :error_message="error_message"
        @closeDialog="closeDialog"
      />
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import utils from "./shared/Utils"
  import TaxItem from "./components/TaxItem.vue"
  import { getAllCurrenciesSelect } from "./shared/Currencies";
  import DefaultFilterDate from "./components/filters/DefaultFilterDate.vue"
  import AdminPartnerConfigDialogMessage from "./AdminPartnerConfigDialogMessage"

  export default {
    name: 'AdminPartnerConfigForm',
    components: {
      'error-dialog': AdminPartnerConfigDialogMessage,
      DefaultFilterDate,
      TaxItem
    },
    props: {
      record: {
        type: Object
      },
      createNewPartner: {
        type: Boolean,
        default: false
      },
      set_default_iof_tax: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        currency_config: {
          decimal: ',',
          thousands: '.',
          precision: 2
        },
        company_taxes_items: [
          {label: 'Boleto', value: 'boleto_tax'},
          {label: 'Cartão de Crédito', value: 'receive_credit_card_tax'},
          {label: 'Chargeback', value: 'chargeback_tax'},
          {label: 'IOF Cash-in', value: 'iof_rate'},
          {label: 'IOF Cash-out', value: 'sell_iof_rate'},
          {label: 'Pix Enviado', value: 'sent_pix_tax'},
          {label: 'Pix Recebido', value: 'receive_pix_tax'},
          {label: 'TED Enviado', value: 'sent_ted_tax'},
          {label: 'TED Recebido', value: 'receive_ted_tax'},
          {label: 'Reembolso', value: 'refund_tax'},
          {label: 'SPEI Enviado', value: 'sent_spei_tax'},
          {label: 'SPEI Recebido', value: 'receive_spei_tax'},
          {label: 'Wire Enviado', value: 'sent_wire_tax'},
          {label: 'Wire Recebido', value: 'receive_wire_tax'},
          {label: 'Oxxo', value: 'oxxo_tax'},
          {label: 'PSE Recebido', value: 'pse_tax'},
          {label: 'PSE Enviado', value: 'sent_pse_tax'}
        ],
        company_taxes_list: [],
        tax_names_translations: {
          boleto_tax: 'Boleto',
          receive_credit_card_tax: 'Cartão de Crédito',
          chargeback_tax: 'Chargeback',
          sent_pix_tax: 'Pix Enviado',
          receive_pix_tax: 'Pix Recebido',
          sent_ted_tax: 'TED Enviado',
          receive_ted_tax: 'TED Recebido',
          refund_tax: 'Reembolso',
          sent_spei_tax: 'SPEI Enviado',
          received_spei_tax: 'SPEI Recebido',
          sent_wire_tax: 'Wire Enviado',
          receive_wire_tax: 'Wire Recebido',
          iof_rate: 'IOF Cash-in',
          sell_iof_rate: 'IOF Cash-out',
          oxxo_tax: 'Oxxo',
          pse_tax: 'PSE Recebido',
          sent_pse_tax: 'PSE Enviado'
        },
        selected_company_tax: {},
        partner_config: {
          automatic_exchange: "never",
          allow_credit_card: "only_3DS",
          store_bank_account: false,
          allow_automatic_pix: false,
          allow_automatic_cobre: false,
          extra_cpf_check: false,
          verify_payer_document: false,
          legacy_webhooks: false,
          legacy_webhooks: false,
          allow_to_create_many_internal_bank_accounts: false,
          disable_autoschedule_creation: false,
          disable_rfc_pf_curp_validation: false,
          allow_to_create_transaction_without_subject: false,
          allow_dynamic_clabe: false,
          allow_checkout_page: "disabled",
          allow_automatic_spei: false,
          disable_handle_clearance_by_currency: [],
          global_pix_bank_account_id: ""
        },
        exchange_mode_values: [
          { text: 'Apenas FX sob demanda', value: 'fx_on_demand'},
          { text: 'Apenas FX automático', value: 'auto_fx'},
          { text: 'Ambos', value: 'any'}
        ],
        automatic_exchange_values: [
          { text: 'Sempre habilitado', value: 'always'},
          { text: 'Automático (BackOffice)', value: 'backoffice_status'},
          { text: 'Desabilitado', value: 'never'}
        ],
        allow_credit_card_values: [
          { text: 'Habilitado', value: 'yes'},
          { text: 'Habilitado apenas 3DS', value: 'only_3DS'},
          { text: 'Desabilitado', value: 'no'}
        ],
        allow_checkout_page_values: [
          { text: 'Débito e Crédito', value: 'both'},
          { text: 'Apenas Débito', value: 'only_debit'},
          { text: 'Apenas Crédito', value: 'only_credit'},
          { text: 'Não', value: 'disabled'}
        ],
        boolean_values: [
          { text: 'Sim', value: true},
          { text: 'Não', value: false}
        ],
        errors: {},
        loading: false,
        fx_rates_list: [],
        fx_rate_value: '',
        companies: [],
        filterDate: null,
        feedback_text: '',
        feedback_color: '',
        filterCurrency: null,
        selectedReport: null,
        display_feedback: false,
        currencyFilterItems: getAllCurrenciesSelect(),
        show_error_dialog: false,
        error_message: ''
      }
    },
    mounted() {
      if(!this.createNewPartner) {
        this.partner_config.automatic_exchange = this.record.partners_config.automatic_exchange
        this.partner_config.exchange_mode = this.record.partners_config.exchange_mode
        this.partner_config.allow_credit_card = this.record.partners_config.allow_credit_card
        this.partner_config.store_bank_account = this.record.partners_config.store_bank_account
        this.partner_config.allow_automatic_pix = this.record.partners_config.allow_automatic_pix
        this.partner_config.allow_automatic_cobre = this.record.partners_config.allow_automatic_cobre
        this.partner_config.extra_cpf_check = this.record.partners_config.extra_cpf_check
        this.partner_config.verify_payer_document = this.record.partners_config.verify_payer_document
        this.partner_config.legacy_webhooks = this.record.partners_config.legacy_webhooks
        this.partner_config.global_pix_bank_account_id = this.record.partners_config.global_pix_bank_account_id
        this.partner_config.allow_checkout_page = this.record.partners_config.allow_checkout_page
        this.partner_config.allow_to_create_many_internal_bank_accounts = this.record.partners_config.allow_to_create_many_internal_bank_accounts
        this.partner_config.disable_autoschedule_creation = this.record.partners_config.disable_autoschedule_creation
        this.partner_config.disable_rfc_pf_curp_validation = this.record.partners_config.disable_rfc_pf_curp_validation
        this.partner_config.allow_to_create_transaction_without_subject = this.record.partners_config.allow_to_create_transaction_without_subject
        this.partner_config.allow_dynamic_clabe = this.record.partners_config.allow_dynamic_clabe
        this.partner_config.allow_automatic_spei = this.record.partners_config.allow_automatic_spei
        this.partner_config.disable_handle_clearance_by_currency = this.record.partners_config.disable_handle_clearance_by_currency
        this.partner_config.allow_financial_account_requests = this.record.partners_config.allow_financial_account_requests
        this.company_taxes_list = this.parseCompanyTaxesInfo(this.record.company_taxes.data)
        this.company_taxes_list.forEach(list_el => {
          this.company_taxes_items.splice(this.company_taxes_items.findIndex(el => el.value == list_el.value), 1)
        })
      } else {
        this.fx_rates_list = [['default', '1.00']]
      }
    },
    updated() {
      if(this.createNewPartner) {
        const companyTaxes = this.buildCompanyTaxesPayload()
        this.$emit('getPartnerConfigAndTaxes', this.partner_config, companyTaxes)
      }
    },
    methods: {
      l(number_value, currency) {
        return utils.currencyToLocal(number_value, currency)
      },
      i18n(str) {
        return this.$root.l(str)
      },
      resetFilter() {
        this.filterDate = null
        this.$refs.filterDate.filterDate = null
        this.filterCurrency = null
      },
      reloadFilterDate(filter_date) {
        this.filterDate = filter_date
      },
      errorMessagesFor(field) {
        if (this.errors[field]) {
          return this.errors[field]
        } else {
          return []
        }
      },
      addTaxToList() {
        let listItem = {}
        listItem['label'] = this.selected_company_tax.label
        listItem['value'] = this.selected_company_tax.value
        listItem['rules'] = []
        if(listItem.value) {
          this.selected_company_tax = {}
          this.company_taxes_list.push(listItem)
          this.company_taxes_items.splice(this.company_taxes_items.findIndex(el => el.value == listItem.value), 1)
        }
      },
      removeTaxFromList(index) {
        const removed_entry = this.company_taxes_list[index].value
        this.company_taxes_list.splice(index, 1)
        if(removed_entry) {
          this.company_taxes_items.push({value: removed_entry, label: this.tax_names_translations[removed_entry]})
        }
      },
      addRateToFxList() {
        if(this.fx_rate_value == '') {
          this.error_message = 'Digite o nome da taxa antes de adicioná-la'
          this.show_error_dialog = true
        } else {
          let listItem = []
          listItem[0] = this.fx_rate_value
          listItem[1] = 0.0
          this.fx_rate_value = ''
          this.fx_rates_list.push(listItem)
        }
      },
      removeRateFromFxList(index) {
        const removed_entry = this.fx_rates_list[index][0]
        if (removed_entry == "default") {
          this.error_message = `A regra "default" não pode ser excluída. Para modificá-la, digite o novo valor em vez de tentar removê-la.`;
          this.show_error_dialog = true
        } else {
          this.fx_rates_list.splice(index, 1)
        }
      },
      buildCompanyTaxesPayload() {
        let payload

        if(this.createNewPartner) {
          payload = this.company_taxes_list.reduce((acc, tax) => {
            return {...acc, [tax.value]: tax.rules}
          }, {})

        } else {
          let empty_attrs = this.company_taxes_items.reduce((acc, item) => {return {...acc, [item.value]: []}}, {})
          payload = this.company_taxes_list.reduce((acc, tax) => {
            return {...acc, [tax.value]: tax.rules}
          }, {...empty_attrs, company_id: this.record.id})
        }

        payload.fx_rate = this.fx_rates_list.reduce((acc, rate) => {
            return {...acc, [rate[0]]: this.toFixedIfNeeded(rate[1], 2)}
          }, {})

        return payload
      },
      toFixedIfNeeded(rate, decimal_places) {
        try {
          return rate.toFixed(decimal_places)
        } catch (error) {
          rate
        }
      },
      parseCompanyTaxesInfo(data) {
        const fixed_rates = ['fx_rate']

        let company_taxes_array = Object.entries(data)
        this.fx_rates_list = Object.entries(data.fx_rate).map(elem => [elem[0], Number(elem[1]).toFixed(2)])


        return company_taxes_array
          .filter(elem => !fixed_rates.includes(elem[0]))
          .filter(elem => elem[1].length > 0)
          .map(elem => [{'value': elem[0], 'rules': elem[1]}][0])
      },
      updateRulesForTax(rules) {
        const el = this.company_taxes_list.findIndex((tax) => tax.value == rules[1])
        this.company_taxes_list[el].rules = rules[0]
        if(!this.createNewPartner) {
          this.display_feedback = true
          this.feedback_text = 'Configuração alterada com sucesso. Ao finalizar, clicar no botão atualizar abaixo da página.'
          this.feedback_color = 'info'
        }
      },
      updatePartnerConfig() {
        this.loading = true
        const payload = { partner_config: this.partner_config }

        let successCallback = (response) => {
          this.$emit('onUpdatePartner', {...this.record, partners_config: this.partner_config})
          this.display_feedback = true
          this.feedback_text = 'Configurações atualizadas com sucesso.'
          this.feedback_color = 'success'
          this.loading = false
        }

        let errorCallback = (response) => {
          this.display_feedback = true
          this.feedback_text = 'Erro ao atualizar as configurações. Entrar em contato com o suporte.'
          this.feedback_color = 'error'
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        this.$http.put(
          this.$root.urls.admin__update_partner_company_config.split('ID').join(this.record.id),
          payload,
          { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      updateCompanyTaxes() {
        const payload = this.buildCompanyTaxesPayload()

        let successCallback = (response) => {
          this.$emit('onUpdatePartner', {...this.record, company_taxes: response.body})
          this.display_feedback = true
          this.feedback_text = 'Taxas atualizadas com sucesso.'
          this.feedback_color = 'success'
          this.$emit('onUpdate')
        }

        let errorCallback = (response) => {
          if (response.body.errors) {
            let errors = response.body.errors

            for (let field in errors) {
              errors[field] = errors[field].map((error_msg)=>{
                return utils.translateErrorMessage(error_msg, this.$root.lang)
              })
            }
            this.display_feedback = true
            this.feedback_text = 'Erro ao atualizar as taxas.'
            this.feedback_color = 'error'
            this.showErrorDialogIfRequired(errors)
            this.errors = errors
          }
        }

        this.errors = {}
        const token = this.$cookies.get('api_token')
        const company_id = this.record.id
        this.$http.put(this.$root.urls.admin__company_taxes.split('ID').join(company_id), payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      closeDialog() {
        this.error_message = ''
        this.show_error_dialog = false
      },
      showErrorDialogIfRequired(errors) {
        if (errors.fx_rate) {
          const missingErrors = errors.fx_rate.filter(msg => msg.includes("can't be blank"));
          if (missingErrors.length > 0) {
            this.error_message = `Em "Taxas Fixas: FX", a regra "default" é obrigatória. Certifique-se de adicioná-la antes de clicar em "atualizar".`;
            this.show_error_dialog = true
          }

          const invalidErrors = errors.fx_rate.reduce(function(acc, msg){
              if(msg.includes('invalid')) { acc.push(msg.match(/`(.*?)`/)[1]) }
              return acc;
            }, []);
          if (invalidErrors.length > 0) {
            const rules = invalidErrors.join('", "');
            if (invalidErrors.length > 1) {
              this.error_message = `As regras "${rules}" são inválidas. Por favor, certifique-se de que não existe nenhuma regra com valor negativo.`;
            } else {
              this.error_message = `A regra "${rules}" é inválida. Por favor, certifique-se de que o valor desta regra não é negativo.`;
            }
            this.show_error_dialog = true
          }
        }
      }
    },
    metaInfo: {
      title: "Facilita Pay - Partners list"
    }
  }
</script>

<style>
  .partner-taxes {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pb {
    padding-bottom: 40px;
    margin-right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/AdminPartnerConfigForm.vue